import { render } from "./Sidebar.vue?vue&type=template&id=eac4305c&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=eac4305c&lang=scss"
import "./Sidebar.vue?vue&type=style&index=1&id=eac4305c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eac4305c"]])

export default __exports__